





































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'EditDrawerContent',  
  props: {
    title:String,
    clearEnable:{
      type:Boolean,
      default:true
    },
    searchEnable:{
      type:Boolean,
      default:true
    }
  }
})
export default class EditDrawerContent extends Vue {
  title!:string
  clearEnable!:boolean
  searchEnable!:boolean

  get rightDrawerOpen() {
    //@ts-ignore
    return this.$store.myGetters.rightDrawerOpen && this.$vuetify.breakpoint.mobile
  }

  set rightDrawerOpen(newValue:boolean) {
    this.$store.myActions.UI_SET_RIGHT_DRAWER_OPEN(newValue)
  }

  clearSearch() {
    this.rightDrawerOpen = false
    this.$emit('clearSearch')
  }
  
   search() {    
    this.rightDrawerOpen = false
    this.$emit("search")
  }  

  mounted() {
    //on enable le rightDrawer (il est desacivé a chaque changement de route par default d'ou le nextTick)
    this.$nextTick(()=> this.$store.myActions.UI_SET_RIGHT_DRAWER_ENABLE(true))
  }

}
